import { jsx as _jsx } from "react/jsx-runtime";
import classnames from 'classnames';
import style from '../../index.module.scss';
import Anger from './png/anger.png';
import Awesome from './png/awesome.png';
import Happy from './png/happy.png';
import Mmmh from './png/mmmh.png';
import Sad from './png/sad.png';
const ratings = {
    1: Anger,
    2: Sad,
    3: Mmmh,
    4: Happy,
    5: Awesome,
};
export const Emoji = ({ score, isSelected, size, }) => (_jsx("img", { src: ratings[score], alt: score.toString(), style: { width: size, height: size }, className: classnames(style.emojiIcon, { [style.selected]: isSelected }) }));
